// extracted by mini-css-extract-plugin
export default {"root":"ErrorFallback_root__Hz6gc","errorText":"ErrorFallback_errorText__NQq+H"};